import axios from 'axios'
import { URL } from '../../../../config'

export const postBakerGames = function (updates,token) 
{
  const bakergamesEndpoint = `/bakergames/update`
  const  bakergamesURL =  `${URL.postevent}${bakergamesEndpoint}` 
  return axios.post(bakergamesURL,updates,
	{ 
    crossdomain: true,
    headers: {
      'Access-Control-Allow-Origin' : '*',
      'Access-Control-Allow-Methods' : 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
      'Authorization' : `Bearer ${token}` 
    }
  })

}


// WEBPACK FOOTER //
// ./src/components/pages/Event/api/postBakerGames.js